/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Editor_TitleInputs */

const fr_legal_editor_title = /** @type {(inputs: Legal_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Édition du site`)
};

const en_legal_editor_title = /** @type {(inputs: Legal_Editor_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site editor`)
};

/**
* | output |
* | --- |
* | "Site editor" |
*
* @param {Legal_Editor_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_editor_title = /** @type {((inputs?: Legal_Editor_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Editor_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_editor_title(inputs)
	return en_legal_editor_title(inputs)
});